import React from "react";

const Logo = () => {
  return (
    <svg
    width="102"
    height="27"
    viewBox="0 0 211 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_221_11374)">
      <path
        d="M7.88876 0.199855C12.434 -1.0122 19.584 3.59779 23.2203 5.7189C31.7049 10.8701 39.1642 14.9192 47.1368 21.0515C50.8162 24.1177 54.5987 28.9206 49.5895 33.9295C47.4688 36.0506 47.7283 36.3681 45.9101 35.1562C39.7777 31.4764 27.0305 23.1072 20.6672 19.1681C18.2429 17.653 15.2471 16.1455 12.7945 18.5984C10.9547 22.8911 14.3604 24.1394 17.0876 25.9575C22.5419 29.5938 27.5773 32.1333 33.0318 35.7691C34.2581 36.5867 40.3909 39.7733 40.3909 41.2884C40.6939 42.1976 37.3174 44.665 36.7112 44.9678C35.1963 45.877 33.7842 47.4209 31.8051 46.8076C27.5815 45.4984 23.0126 41.5698 19.6793 39.4489C16.7636 37.5933 13.5467 38.8355 12.9334 39.4489C10.4804 41.9018 12.5942 44.0153 12.9334 44.3545C13.3698 44.7909 24.1359 50.5014 23.8329 51.7136C23.8329 52.6225 20.7596 54.4766 20.1535 54.7798C17.7295 56.2948 16.1349 56.6268 13.4078 57.2327C6.74129 58.7479 2.66495 55.6312 1.75592 49.8738C-0.0622183 38.9655 -0.544296 23.7132 0.667783 12.8048C1.57682 7.95652 1.82835 1.41191 7.88876 0.199855Z"
        fill="#006EFA"
      ></path>
      <path
        d="M89.72 14.7668V20.2468H82.28V42.8468H75.44V20.2468H68V14.7668H89.72Z"
        fill="#0A0E12"
      ></path>
      <path
        d="M111.433 37.8868H100.953L99.2728 42.8468H92.1128L102.273 14.7668H110.193L120.353 42.8468H113.113L111.433 37.8868ZM109.673 32.6068L106.193 22.3268L102.753 32.6068H109.673Z"
        fill="#0A0E12"
      ></path>
      <path
        d="M144.445 14.7668V20.2468H137.005V42.8468H130.165V20.2468H122.725V14.7668H144.445Z"
        fill="#0A0E12"
      ></path>
      <path
        d="M168.878 14.7668V20.2468H161.438V42.8468H154.598V20.2468H147.158V14.7668H168.878Z"
        fill="#0A0E12"
      ></path>
      <path
        d="M179.951 37.5668H188.911V42.8468H173.111V14.7668H179.951V37.5668Z"
        fill="#0A0E12"
      ></path>
      <path
        d="M199.813 20.2468V25.9268H208.973V31.2068H199.813V37.3668H210.173V42.8468H192.973V14.7668H210.173V20.2468H199.813Z"
        fill="#0A0E12"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_221_11374">
        <rect width="210.173" height="57.233" rx="4" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
  );
};

export default Logo;
